import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

/**
 * CSS Import Order - DO NOT REORDER
 * Design system overrides depend on this exact order.
 */

/* 1. Core Ionic CSS (REQUIRED) */
import '@ionic/react/css/core.css';

/* 2. Basic Ionic CSS */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* 3. Optional Ionic Utilities */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* 4. Theme variables */
import './theme/variables.css';

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
